import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginPage from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import RegisterPage from './pages/Register';
import Sidebar from './components/Sidebar.jsx';
import Navbar from './components/Navbar.jsx';
import About from './pages/About.jsx';
import Home from './pages/Home.jsx';
import Score from './pages/Score.jsx';
import Certificate from './pages/Certificate.jsx';
import CoursePage from './pages/Course.jsx';
import CourseDetail from './pages/CourseDetail.jsx';
import Messages from './pages/Messages.jsx';
import MessagesDetail from './pages/MessageDetail.jsx';
import LoginAsStudent from './pages/LoginAsStudent.jsx';
import FailedPayment from './pages/FailedPayment.jsx';
import SuccessPayment from './pages/SuccessPayment.jsx';

// Layout اصلی با Sidebar و Navbar
const Layout = () => {
  return (
    <div className="app-layout">
      <div className="main-content">
        <Navbar />
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
      <div className="sidebar-right">
        <Sidebar />
      </div>
    </div>
  );
};

// Layout خالی برای صفحات پرداخت (بدون Sidebar و Navbar)
const EmptyLayout = () => {
  return (
    <div className="empty-layout">
      <Outlet />
    </div>
  );
};

const ProtectedRoute = () => {
  const token = localStorage.getItem('accessToken');
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

function App() {
  const token = localStorage.getItem('accessToken');
  return (
    <div>
      <Router>
        <Routes>
          {/* صفحات عمومی - بدون احراز هویت */}
          <Route path="/login-as-student" element={<LoginAsStudent />} />
          <Route
            path="/login"
            element={token ? <Navigate to="/" replace /> : <LoginPage />}
          />
          <Route path="register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* صفحات بدون Sidebar و Navbar - با پشتیبانی از اسلش آخر */}
          <Route element={<EmptyLayout />}>
            <Route path="certificate/:id" element={<Certificate />} />
            <Route path="message-detail/:id" element={<MessagesDetail />} />
            <Route path="course-detail/:id" element={<CourseDetail />} />
            
            {/* مسیرهای پرداخت موفق - برای لوکال‌هاست */}
            <Route path="success-payment" element={<SuccessPayment />} />
            <Route path="success-payment/" element={<SuccessPayment />} />
            
            {/* مسیرهای پرداخت ناموفق - برای لوکال‌هاست */}
            <Route path="faild-payment" element={<FailedPayment />} />
            <Route path="faild-payment/" element={<FailedPayment />} />
            <Route path="failed-payment" element={<FailedPayment />} />
            <Route path="failed-payment/" element={<FailedPayment />} />
          </Route>

          {/* صفحات محافظت شده با احراز هویت */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="course" element={<CoursePage />} />
              <Route path="message" element={<Messages />} />
              <Route path="score" element={<Score />} />
            </Route>
          </Route>

          {/* صفحه 404 - مسیر نامعتبر */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;